import React from 'react';
import {SportsBookImages} from '../../utils/gameUtils';
import {makeStyles} from '@material-ui/core/styles';

export const styles = makeStyles(theme => ({
    logo: {
        maxWidth: '65px',
        [theme.breakpoints.up('sm')]: {
            maxWidth: '93px',
        }
    },
}));

export function SportsBook({name}) {
    const imagePath = (name) => {
        let path = `${process.env.PUBLIC_URL}/images/sportBooks/${SportsBookImages[name]}`;

        if (path.startsWith('.')) {
            path = path.substring(1);
        }

        return path;
    }
    return (
        <>
            {/* <img onClick={() => goToHome(league, history)}  src={imagePath(name)} /> */}
            <img alt="sports book" src={imagePath(name)}/>
        </>
    );
}
